import { ViewUploadComponent } from './shared/components/view-upload/view-upload.component';
import { ViewTrainingComponent } from './shared/components/view-training/view-training.component';
import { ViewUserProfileComponent } from './shared/components/view-user-profile/view-user-profile.component';
import { CoreResolverService } from './core/services/core-resolver.service';
import { UnauthorisedAccessPageComponent } from './core/components/unauthorised-access-page/unauthorised-access-page.component';
import { AuthGuard } from './core/guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// user defined components/services
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { MsalGuard } from '@azure/msal-angular';
import {
  MANAGE_ASSESTS_URL,
  MANAGE_USERS_URL,
  DASHBOARD_URL,
  WORKFLOWS_DASHBOARD_URL,
  PAGE_NOT_FOUND_URL,
  FULL_PATH,
  UN_AUTHORIZED_URL,
  MANAGE_REPORTING_LIFECYCLE_URL,
  MANAGE_WORKFLOWS_URL,
  CP_QP_MANAGE_WORKFLOWS_URL,
  ORC_MANAGE_WORKFLOWS_URL,
  ENDORSER_MANAGE_WORKFLOWS_URL,
  USER_PROFILE_URL,
  AFFILIATION,
  TRAINING,
  UPLOADS,
  CP_QP_ORC_MANAGE_WORKFLOWS_URL,
  REPORT_EXPORTS,
  REPORT_EXPORTS_URL,
  CONSUMER_MANAGE_WORKFLOWS_URL,
  MANAGE_CONFIGURATION_URL,
  MANAGE_DOCUMENTS,
  MANAGE_DOCUMENTS_URL,
} from './shared/constants/constant';
import { ViewAffiliationComponent } from './shared/components/view-affiliation/view-affiliation.component';
import { UserProfileComponent } from './modules/manage-users/components/user-profile/user-profile.component';
import { CreateUpdateProfileComponent } from './modules/manage-users/components/create-update-profile/create-update-profile.component';

const routes: Routes = [
  {
    path: MANAGE_USERS_URL,
    loadChildren: () =>
      import('./modules/manage-users/manage-users.module').then(
        (m) => m.ManageUsersModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: DASHBOARD_URL,
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: MANAGE_ASSESTS_URL,
    loadChildren: () =>
      import('./modules/manage-assets/manage-assets.module').then(
        (m) => m.ManageAssetsModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: MANAGE_REPORTING_LIFECYCLE_URL,
    loadChildren: () =>
      import('./modules/manage-reporting-cycle/manage-reporting.module').then(
        (m) => m.ManageReportingModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: MANAGE_WORKFLOWS_URL,
    loadChildren: () =>
      import('./modules/manage-workflows/manage-workflows.module').then(
        (m) => m.ManageWorkflowsModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: CP_QP_MANAGE_WORKFLOWS_URL,
    loadChildren: () =>
      import(
        './modules/cp-qp-manage-workflow/cp-qp-manage-workflow.module'
      ).then((m) => m.CpQpManageWorkflowModule),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: CP_QP_ORC_MANAGE_WORKFLOWS_URL,
    loadChildren: () =>
      import(
        './modules/cp-qp-orc-manage-workflow/cp-qp-orc-manage-workflow.module'
      ).then((m) => m.CpQpOrcManageWorkflowModule),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: ORC_MANAGE_WORKFLOWS_URL,
    loadChildren: () =>
      import('./modules/orc-manage-workflow/orc-manage-workflow.module').then(
        (m) => m.OrcManageWorkflowModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: ENDORSER_MANAGE_WORKFLOWS_URL,
    // tslint:disable-next-line: max-line-length
    loadChildren: () =>
      import(
        './modules/endorser-manage-workflow/endorser-manage-workflow.module'
      ).then((m) => m.EndorserManageWorkflowModule),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: CONSUMER_MANAGE_WORKFLOWS_URL,
    // tslint:disable-next-line: max-line-length
    loadChildren: () =>
      import(
        './modules/consumer-manage-workflow/consumer-manage-workflow.module'
      ).then((m) => m.ConsumerManageWorkflowModule),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: `${DASHBOARD_URL}/user/:id`,
    component: UserProfileComponent,
    children: [
      {
        path: USER_PROFILE_URL,
        component: CreateUpdateProfileComponent,
        resolve: {
          data: CoreResolverService,
        },
      },
      {
        path: AFFILIATION,
        component: ViewAffiliationComponent,
        resolve: {
          data: CoreResolverService,
        },
      },
      {
        path: TRAINING,
        component: ViewTrainingComponent,
        resolve: {
          data: CoreResolverService,
        },
      },
      {
        path: UPLOADS,
        component: ViewUploadComponent,
        resolve: {
          data: CoreResolverService,
        },
      },
      {
        path: '',
        redirectTo: USER_PROFILE_URL,
        pathMatch: 'full',
      },
    ],
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: WORKFLOWS_DASHBOARD_URL,
    loadChildren: () =>
      import('./modules/manage-dashboard/manage-dashboard.module').then(
        (m) => m.ManageDashboardModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: REPORT_EXPORTS_URL,
    loadChildren: () =>
      import('./modules/reporting-exports/reporting-exports.module').then(
        (m) => m.ReportingExportsModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: MANAGE_CONFIGURATION_URL,
    loadChildren: () =>
      import('./modules/manage-configuration/manage-configuration.module').then(
        (m) => m.ManageConfigurationModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: MANAGE_DOCUMENTS_URL,
    loadChildren: () =>
      import('./modules/manage-documents/manage-documents.module').then(
        (m) => m.ManageDocumentsModule
      ),
    resolve: {
      data: CoreResolverService,
    },
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: PAGE_NOT_FOUND_URL,
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: UN_AUTHORIZED_URL,
    component: UnauthorisedAccessPageComponent,
  },
  {
    path: '',
    redirectTo: `/${DASHBOARD_URL}`,
    pathMatch: FULL_PATH,
  },
  {
    path: '**',
    redirectTo: `/${PAGE_NOT_FOUND_URL}`,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
